// extracted by mini-css-extract-plugin
module.exports = {"form-container":"EvidenceOfInsuranceform_form-container__1TWpj"};